/* 🤖 this file was generated by svg-to-ts */
export const kzIconsValidCheckRounded: {
  name: 'valid_check_rounded';
  data: string;
} = {
  name: 'valid_check_rounded',
  data: `<svg fill="none" viewBox="0 0 16 16"><path d="M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.333 6 6.75 10.667 4.667 8.545" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
